import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { linkMatch } from "./chunk-KNR3DFGN.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/Util.ts

var Util_exports = {};

__export(Util_exports, {
  blockBubble: function blockBubble() {
    return _blockBubble;
  },
  checkIsAbortError: function checkIsAbortError() {
    return _checkIsAbortError;
  },
  escapeRegExp: function escapeRegExp() {
    return _escapeRegExp;
  },
  formatDecimal: function formatDecimal() {
    return _formatDecimal;
  },
  getBackLocale: function getBackLocale() {
    return _getBackLocale;
  },
  getFormattedLinksContext: function getFormattedLinksContext() {
    return _getFormattedLinksContext;
  },
  getLocale: function getLocale() {
    return _getLocale;
  },
  getMediaTypeFromFile: function getMediaTypeFromFile() {
    return _getMediaTypeFromFile;
  },
  getMessageFromPlainText: function getMessageFromPlainText() {
    return _getMessageFromPlainText;
  },
  getMimeTypeFromURL: function getMimeTypeFromURL() {
    return _getMimeTypeFromURL;
  },
  getParentWindowURL: function getParentWindowURL() {
    return _getParentWindowURL;
  },
  getPreviewMessageFromMediaFile: function getPreviewMessageFromMediaFile() {
    return _getPreviewMessageFromMediaFile;
  },
  getWebObjectURL: function getWebObjectURL() {
    return _getWebObjectURL;
  },
  isStreamingURL: function isStreamingURL() {
    return _isStreamingURL;
  },
  isURL: function isURL() {
    return _isURL;
  },
  isValidAmount: function isValidAmount() {
    return _isValidAmount;
  },
  minLength: function minLength() {
    return _minLength;
  },
  objectToArray: function objectToArray() {
    return _objectToArray;
  },
  phoneChecks: function phoneChecks() {
    return _phoneChecks;
  },
  postMessageToParentFrame: function postMessageToParentFrame() {
    return _postMessageToParentFrame;
  },
  removeNil: function removeNil() {
    return _removeNil;
  },
  removeWebObjectUrl: function removeWebObjectUrl() {
    return _removeWebObjectUrl;
  },
  renameKeys: function renameKeys() {
    return _renameKeys;
  },
  requiredEmail: function requiredEmail() {
    return _requiredEmail;
  },
  round: function round() {
    return _round;
  },
  stringInsert: function stringInsert() {
    return _stringInsert;
  },
  stringReplace: function stringReplace() {
    return _stringReplace;
  },
  stringReplaceInRange: function stringReplaceInRange() {
    return _stringReplaceInRange;
  },
  toFixedCheck: function toFixedCheck() {
    return _toFixedCheck;
  }
});

import _ from "lodash";
import mime from "mime";
import * as R from "ramda";
import * as uuid from "uuid";

var _objectToArray = function _objectToArray(object) {
  return _.map(_.toPairs(object), function (d) {
    return _.fromPairs([d]);
  });
};

var _stringInsert = function _stringInsert(str, index, value) {
  return str.substr(0, index + 1) + value + str.substr(index + 1);
};

var _stringReplace = function _stringReplace(str, index, value) {
  var size = value.length;

  var _index = index - size;

  var firstPart = str.substring(0, _index);
  var secondPart = str.substring(index);
  return "".concat(firstPart).concat(secondPart);
};

var _stringReplaceInRange = function _stringReplaceInRange(str, value, l, r) {
  var firstPart = str.substring(0, l);
  var secondPart = str.substring(r);
  return "".concat(firstPart).concat(value).concat(secondPart);
};

var _round = function _round(num) {
  var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return Number((Math.round(num * Math.pow(10, pos)) / Math.pow(10, pos)).toFixed(pos));
};

var _isURL = function _isURL(str) {
  var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return regexp.test(str);
};

var _formatDecimal = function _formatDecimal(value) {
  return _.replace(value, ",", ".");
};

var _isValidAmount = function _isValidAmount(amount) {
  var allowed = amount == "" || amount.match(/^[0-9]+$/) || amount.match(/^[0-9]+\.$/) || amount.match(/^[0-9]+\.[0-9]+$/);
  var disAllowed = amount.match(/^0[0-9].*/);
  return !allowed || disAllowed;
};

var _getLocale = function _getLocale(lng) {
  var locale = "en";

  switch (lng) {
    case "en":
      locale = "en";
      break;

    case "zh_TW":
      locale = "zh-tw";
      break;

    case "zh_CN":
      locale = "zh-cn";
      break;

    case "jp":
      locale = "ja";
      break;

    default:
      locale = "en";
      break;
  }

  return locale;
};

var _getBackLocale = function _getBackLocale(lng) {
  var locale = "en-US";

  switch (lng) {
    case "en":
      locale = "en-US";
      break;

    case "zh_TW":
      locale = "zh-TW";
      break;

    case "zh_CN":
      locale = "zh-CN";
      break;

    case "jp":
      locale = "ja";
      break;

    default:
      locale = "en-US";
      break;
  }

  return locale;
};

var _requiredEmail = function _requiredEmail(value) {
  return (value === "" || !value || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) && "error";
};

var _minLength = function _minLength(min, value) {
  return (!value || value.length < min) && "error";
};

var _phoneChecks = {
  "+86": /^(\+?0?86-?)?1[3456789]\d{9}$/,
  "+852": /^(\+?852-?)?[569]\d{3}-?\d{4}$/,
  "+886": /^(\+?886-?)?09\d{8}$/
};

var _toFixedCheck = function _toFixedCheck(value) {
  var check = /^[0-9]+(\.[0-9]{1,2})?$/;

  if (!check.test(value)) {
    return value.toFixed(2);
  } else {
    return value;
  }
};

var _getParentWindowURL = function _getParentWindowURL() {
  var _window, _window2, _window3, _document, _document$location;

  return ((_window = window) === null || _window === void 0 ? void 0 : _window.location) !== ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.parent.location) ? (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.parent.location.origin : (_document = document) === null || _document === void 0 ? void 0 : (_document$location = _document.location) === null || _document$location === void 0 ? void 0 : _document$location.origin;
};

var _postMessageToParentFrame = function _postMessageToParentFrame(data) {
  console.log("postMessageToParentFrame", data);
  window.parent.postMessage(JSON.stringify(data), _getParentWindowURL());
};

var _renameKeys = function _renameKeys(keysMap) {
  return function (obj) {
    return Object.entries(obj).reduce(function (a, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      return k in keysMap ? _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, keysMap[k], v)) : _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, k, v));
    }, {});
  };
};

var _getMimeTypeFromURL = function _getMimeTypeFromURL(url) {
  var segments = new URL(url).pathname.split("/");
  var last = segments.pop() || segments.pop() || "";
  return mime.getType(last);
};

var _blockBubble = function _blockBubble(e) {
  var _e$nativeEvent;

  e.stopPropagation();
  (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : _e$nativeEvent.stopImmediatePropagation();
};

var _getWebObjectURL = function _getWebObjectURL(file) {
  var _URL, _webkitURL;

  var url;

  if (((_URL = URL) === null || _URL === void 0 ? void 0 : _URL.createObjectURL) !== void 0) {
    url = URL.createObjectURL(file);
  } else if (((_webkitURL = webkitURL) === null || _webkitURL === void 0 ? void 0 : _webkitURL.createObjectURL) !== void 0) {
    url = webkitURL.createObjectURL(file);
  }

  return url;
};

var _removeWebObjectUrl = function _removeWebObjectUrl(url) {
  var _URL2, _webkitURL2;

  if (((_URL2 = URL) === null || _URL2 === void 0 ? void 0 : _URL2.revokeObjectURL) !== void 0) {
    URL.revokeObjectURL(url);
  } else if (((_webkitURL2 = webkitURL) === null || _webkitURL2 === void 0 ? void 0 : _webkitURL2.revokeObjectURL) !== void 0) {
    webkitURL.revokeObjectURL(url);
  }
};

var _getMediaTypeFromFile = function _getMediaTypeFromFile(file) {
  var _file$type, _file$type$split, _file$type$split$;

  return file === null || file === void 0 ? void 0 : (_file$type = file.type) === null || _file$type === void 0 ? void 0 : (_file$type$split = _file$type.split("/")) === null || _file$type$split === void 0 ? void 0 : (_file$type$split$ = _file$type$split[0]) === null || _file$type$split$ === void 0 ? void 0 : _file$type$split$.toLocaleLowerCase();
};

var _getPreviewMessageFromMediaFile = function _getPreviewMessageFromMediaFile(file, user) {
  var mType = _getMediaTypeFromFile(file);

  return {
    mediaType: mType,
    text: "",
    user: user,
    _id: uuid.v4()
  };
};

var _getMessageFromPlainText = function _getMessageFromPlainText(text, user) {
  return {
    _id: uuid.v4(),
    user: user,
    text: text,
    createdAt: /* @__PURE__ */new Date()
  };
};

var _isStreamingURL = function _isStreamingURL(url) {
  return url === null || url === void 0 ? void 0 : url.endsWith(".m3u8");
};

var _removeNil = R.pipe(R.map(R.when(R.is(Object), function (v) {
  return _removeNil(v);
})), R.reject(R.ifElse(R.is(String), R.F, R.either(R.isEmpty, R.isNil))));

var _escapeRegExp = R.when(R.is(String), R.replace(/[.*+?^${}()|[\]\\-]/g, "\\$&"));

var _getFormattedLinksContext = function _getFormattedLinksContext(text) {
  var match,
      offset = 0;
  var contextArray = [];

  while (match = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch.exec(text)) {
    var _match$;

    contextArray.push({
      text: text.substring(offset, match.index)
    });
    contextArray.push({
      link: match[0]
    });
    offset = match.index + (((_match$ = match[0]) === null || _match$ === void 0 ? void 0 : _match$.length) || 0);
  }

  if (offset !== text.length) {
    contextArray.push({
      text: text.substring(offset)
    });
  }

  return contextArray;
};

var _checkIsAbortError = function _checkIsAbortError(error) {
  return error instanceof Error && error.name === "AbortError";
};

export { _objectToArray as objectToArray, _stringInsert as stringInsert, _stringReplace as stringReplace, _stringReplaceInRange as stringReplaceInRange, _round as round, _isURL as isURL, _formatDecimal as formatDecimal, _isValidAmount as isValidAmount, _getLocale as getLocale, _getBackLocale as getBackLocale, _requiredEmail as requiredEmail, _minLength as minLength, _phoneChecks as phoneChecks, _toFixedCheck as toFixedCheck, _getParentWindowURL as getParentWindowURL, _postMessageToParentFrame as postMessageToParentFrame, _renameKeys as renameKeys, _getMimeTypeFromURL as getMimeTypeFromURL, _blockBubble as blockBubble, _getWebObjectURL as getWebObjectURL, _removeWebObjectUrl as removeWebObjectUrl, _getMediaTypeFromFile as getMediaTypeFromFile, _getPreviewMessageFromMediaFile as getPreviewMessageFromMediaFile, _getMessageFromPlainText as getMessageFromPlainText, _isStreamingURL as isStreamingURL, _removeNil as removeNil, _escapeRegExp as escapeRegExp, _getFormattedLinksContext as getFormattedLinksContext, _checkIsAbortError as checkIsAbortError, Util_exports };